import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "cq-accordion",
  templateUrl: "./cq-accordion.component.html",
  styleUrls: ["./cq-accordion.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class CQAccordionComponent implements OnInit {
  @Input() items: any[] = [];
  @Input() title: string = "";
  @Input() isShowTitle: boolean = false;
  @Input() isOneOpened: boolean = false;
  @Input() openedTabs: number[] = [];

  public activeIndexes: number[] = [];

  ngOnInit(): void {
    if (this.openedTabs.length) {
      this.activeIndexes = [...this.openedTabs];
    }
  }

  toggle(index: number): void {
    const pos = this.activeIndexes.indexOf(index);
    if (this.isOneOpened) {
      this.activeIndexes = pos > -1 ? [] : [index];
    } else {
      if (pos > -1) {
        this.activeIndexes.splice(pos, 1);
      } else {
        this.activeIndexes.push(index);
      }
    }
  }
}
